import StepOne from "./Steps/StepOne.js";
import { useState, useRef, useCallback } from "react";
import { useSystem } from "../../hooks/use-system.js";
import { defaultLanguage } from "../../constants/languages.js";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import featureImg from "../../assets/images/feature-image.jpeg";
import desktopNordLogo from "../../assets/images/nordvpn-logo.png";

export default function NordNetherlands() {
  const { config, language } = useSystem();
  const [registerStep, setRegisterStep] = useState(0);

  const stepOneRef = useRef(null);
  const stepTwoRef = useRef(null);
  const nodeRef = registerStep === 0 ? stepOneRef : stepTwoRef;
  const [verificationRequest, setVerificationRequest] = useState(null);
  const [carrierCode, setCarrierCode] = useState(null);

  const handleVerificationRequest = useCallback((value) => {
    setVerificationRequest(value);
  }, []);

  const handleCarrierCode = useCallback((value) => {
    setCarrierCode(value);
  }, []);

  return (
    <>
      <div
        className="shadow-md flex flex-col md:flex-row w-full h-screen md:h-auto lg:h-screen justify-between bg-[#E3E3E3] "
        style={{
          // backgroundImage: `url(${config.background_image})`,
          // backgroundColor: config.background_color,
          color: config.text_color,
          fontFamily: config.font_family,
        }}
      >
        <div className="flex md:hidden justify-center items-center w-full bg-black py-2">
          <span
            className="text-sm"
            style={{
              color: "#fff",
            }}
          >
            {config.texts?.[language || defaultLanguage]?.[0]?.header_text ||
              ""}
          </span>
        </div>
        <div className="md:w-1/2  justify-center items-center relative sm:flex image-container ">
          <img
            src={featureImg}
            alt="Background"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 lg:hidden">
            <div className="text-center text-white">
              <svg
                width="84"
                height="69"
                viewBox="0 0 84 69"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.18046 68.3914C3.04255 61.0479 0.28125 52.1549 0.28125 43.0887C0.28125 19.28 18.841 0 41.7115 0C64.5799 0 83.1417 19.2778 83.1417 43.0887C83.1417 52.1549 80.3783 61.0479 75.2404 68.3914L55.3577 34.7685L53.4235 38.1539L55.3577 47.5641L41.7136 23.2381L33.2609 38.0983L35.2485 47.5641L28.0674 34.8262L8.18046 68.3914Z"
                  fill="white"
                />
              </svg>
              <p className="font-semibold text-lg">NordVPN</p>
            </div>
          </div>
        </div>
        <div className="md:w-1/2 h-screen md:h-auto justify-between items-center flex flex-col relative  bg-[#E3E3E3]">
          <div className="w-full flex flex-col justify-center items-start max-w-[600px] px-4 md:px-0  md:mt-10">
            <div className="w-full hidden lg:flex justify-center items-center mt-10 mb-10">
              <div className="flex flex-col items-center ">
                <img src={desktopNordLogo} alt="Logo" />
              </div>
            </div>
            <div className="w-full flex justify-center items-center mt-10 md:mt-0">
              <h2
                className="text-center font-bold lg:text-3xl md:text-xl text-xl leading-snug"
                style={{
                  color: config.titles_color || "#000",
                }}
              >
                {config.texts?.[language || defaultLanguage]?.[registerStep]
                  ?.title || ""}
              </h2>
            </div>
            {config.texts?.[language || defaultLanguage]?.[registerStep]
              ?.sec_title && (
              <div className="w-full flex justify-center items-center">
                <p
                  className="text-md text-sm md:text-lg"
                  style={{
                    color: config.titles_color || "#000",
                  }}
                >
                  {
                    config.texts?.[language || defaultLanguage]?.[registerStep]
                      ?.sec_title
                  }
                </p>
              </div>
            )}

            <div className="w-full items-center justify-center">
              <SwitchTransition mode="out-in">
                <CSSTransition
                  key={registerStep}
                  classNames="fade"
                  nodeRef={nodeRef}
                  addEndListener={(done) => {
                    nodeRef.current.addEventListener(
                      "transitionend",
                      done,
                      false
                    );
                  }}
                  timeout={1000}
                >
                  <div ref={nodeRef}>
                    {registerStep === 0 ? (
                      <StepOne
                        setStep={setRegisterStep}
                        config={config}
                        language={language}
                        handleVerificationRequest={handleVerificationRequest}
                        handleCarrierCode={handleCarrierCode}
                      />
                    ) : null}
                  </div>
                </CSSTransition>
              </SwitchTransition>
            </div>

            <div className="text-center w-full flex-col items-center  justify-center ">
              <div
                className="font-medium text-[10px] text-center leading-[12px] flex flex-col gap-2 w-full"
                dangerouslySetInnerHTML={{
                  __html:
                    config.texts?.[language || defaultLanguage]?.[registerStep]
                      ?.paragraph_under_button || "",
                }}
              ></div>
            </div>
          </div>
          <div className="flex flex-col items-center w-full gap-3 bg-[#E3E3E3]">
            {config.flow_icon && (
              <div className="w-full my-1">
                <img
                  src={config.flow_icon}
                  alt="Flow Icon"
                  className="mx-auto"
                />
              </div>
            )}
            <div className="w-full flex flex-wrap justify-center text-sm text-center space-x-4">
              <a href={config.terms_url} className="text-gray-700">
                {config.translations?.[language || defaultLanguage]?.terms}
              </a>

              {config.policy_url && (
                <>
                  <a
                    href={config.policy_url}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: config.titles_color }}
                    className="text-gray-700"
                  >
                    {config.translations?.[language || defaultLanguage]?.policy}
                  </a>
                </>
              )}

              {config.about_url && (
                <>
                  <a
                    href={config.about_url}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: config.titles_color }}
                    className="text-gray-700"
                  >
                    {config.translations?.[language || defaultLanguage]?.about}
                  </a>
                </>
              )}

              {config.disclaimer_url && (
                <>
                  <a
                    href={config.disclaimer_url}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: config.titles_color }}
                    className="text-gray-700"
                  >
                    {
                      config.translations?.[language || defaultLanguage]
                        ?.disclaimer
                    }
                  </a>
                </>
              )}

              {config.contact_us_url && (
                <>
                  <a
                    href={config.contact_us_url}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: config.titles_color }}
                    className="text-gray-700"
                  >
                    {
                      config.translations?.[language || defaultLanguage]
                        ?.contact
                    }
                  </a>
                </>
              )}
            </div>
            <div
              className="flex p-2 justify-center lg:absolute lg:bottom-0 w-full"
              style={{ background: "#000" }}
            >
              <span style={{ color: "#FFF" }}>
                Copyright {new Date().getFullYear()} - &nbsp;
              </span>{" "}
              <a
                href="https://dcb-checkout.com"
                target="_blank"
                style={{
                  textDecoration: "none",
                  color: "#FFFFFF",
                  fontWeight: "bold",
                }}
              >
                DCB{" "}
                <span
                  style={{
                    background:
                      "linear-gradient(92.32deg, #7538F0 -3.12%, #F233E7 100.39%)",
                    webkitBackgroundClip: "text",
                    webkitTextFillColor: "transparent",
                  }}
                >
                  CHECKOUT
                </span>
              </a>
            </div>
            {config.bottom_text && (
              <div
                className="bg-black text-white text-center py-2 w-full"
                dangerouslySetInnerHTML={{ __html: config.bottom_text }}
              ></div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
